import { Modal } from "react-bootstrap";
import { RiCloseLargeFill } from "react-icons/ri";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { useMemo, useState } from "react";
import Select from "react-select";
import JackpotWinnerServices from "../../../services/JackpotWinnerServices";

// Validation Schema
const validationSchema = Yup.object().shape({
  winner_yantras: Yup.array()
    .of(Yup.number())
    .min(1, "Please select at least 1 winner")
    .required("Winner yantras are required"),
});

const EditJackpotWinnerModal = (props) => {
  const {
    editMWModal,
    setEditMWModal,
    editMWData,
    setEditMWData,
    activeGame,
  gameLabel,
    getJackpotWinnerData,
    yantraList,
  } = props;

  const jackpotWinnerApi = new JackpotWinnerServices();
  const [isLoading, setIsLoading] = useState(false);
  // const [sessionList, setSessionList] = useState([]);
  // const [selectedSession, setSelectedSession] = useState(null);

  const yantraOptions = useMemo(() => {
    const list = Array.isArray(yantraList) ? yantraList : [];
    return list.map((y, idx) => ({
      value: y.id,
      label: `[${idx + 1}] ${y.yantra_name}`,
    }));
  }, [yantraList]);

  const initialWinnerIds = useMemo(() => {
    const raw = String(editMWData?.winner_yantra || "").trim();
    if (!raw) return [];
    return raw
      .split(",")
      .map((v) => Number(String(v).trim()))
      .filter((n) => Number.isFinite(n) && n > 0);
  }, [editMWData]);

  const initialValues = {
    date_filter: "today",
    winner_yantras: initialWinnerIds,
    session_id: editMWData?.id,
  };

  const onClose = () => {
    setEditMWModal(false);
    setEditMWData(null);
  };

  return (
    <Modal
      show={editMWModal}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
      size="md"
    >
      <div className="modal-header border-0 pb-0">
        <h5 className="modal-title">
          Update Multi Winner [{gameLabel || activeGame} Session]
        </h5>
        <button className="btn" onClick={onClose}>
          <RiCloseLargeFill size={20} />
        </button>
      </div>
      <hr className="my-1" />
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values, { setSubmitting }) => {
          setIsLoading(true);
          setSubmitting(true);
          const payload = {
            game: activeGame,
            date_filter: values.date_filter,
            session_id: values.session_id,
            winner_count: (values.winner_yantras || []).length,
            winner_yantras: (values.winner_yantras || []).join(","),
          };
          jackpotWinnerApi
            .updateJackpotWinner(payload)
            .then((response) => {
              if (response.isSuccess) {
                toast.success(response.message);
                onClose();
                getJackpotWinnerData();
              } else {
                toast.error(response.message);
              }
            })
            .catch((error) => {
              console.error("Error in updateJackpotWinner:", error);
              toast.dismiss();
              toast.error(
                error?.response?.data?.message ||
                  "Error in update jackpot winner",
              );
            })
            .finally(() => {
              setIsLoading(false);
              setSubmitting(false);
            });
        }}
      >
        {({ errors, touched, isSubmitting, values, setFieldValue }) => (
          <Form className="addAdmin-form">
            <Modal.Body className="modal-body-scroll">
              <div className="form-group mb-2">
                <label htmlFor="winner_yantras" className="form-label mb-0">
                  Select Winners <span className="required-asterisk">*</span>
                </label>
                <div className="input-wrapper">
                  <Select
                    className="mt-1 w-100"
                    options={yantraOptions}
                    value={yantraOptions.filter((opt) =>
                      (values.winner_yantras || []).includes(opt.value),
                    )}
                    onChange={(selectedItems) => {
                      const list = Array.isArray(selectedItems)
                        ? selectedItems.map((y) => y.value)
                        : [];
                      setFieldValue("winner_yantras", list);
                    }}
                    isMulti={true}
                  />
                </div>
                <ErrorMessage name="winner_yantras">
                  {(msg) => <div className="admin_error-text">{msg}</div>}
                </ErrorMessage>
              </div>
              {/* Submit Button */}
              <div className="d-flex align-items-center justify-content-end">
                <button
                  type="submit"
                  className="add_admin-btn"
                  disabled={isSubmitting || isLoading}
                >
                  {isLoading ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Submitting...
                    </>
                  ) : (
                    "Update Now"
                  )}
                </button>
              </div>
            </Modal.Body>
          </Form>
        )}
      </Formik>
    </Modal>
  );
};

export default EditJackpotWinnerModal;
